import {memo} from "react";
import FileUploadWithProgress from "./FileUploadWithProgress";
import HttpRequest from "../../Http/HttpRequest";
import Notify from "../../Notify/Notify";

const DynamicFileUploader = ({
                                 generateUploadUrl,
                                 ...props
                             }) => {

    const getSignedUrl = async (file, callback) => {
        try {
            console.log('generateUploadUrl', generateUploadUrl);
            const data = await HttpRequest.get(`${process.env.REACT_APP_NODE_SERVICE}/files/upload/genereate-upload-url/certificates`);
            callback({
                uploadDate: data.uploadDate,
                signedUrl: data.url,
                name: data.name
            });
        } catch (e) {
            Notify.error('Falha ao buscar url para upload', e);
        }
    }

    return <FileUploadWithProgress
        {...props}
        getSignedUrl={getSignedUrl}
    />

}

export default memo(DynamicFileUploader);
